/** Раздел "Гарантии" */
export default {
  name: 'guarantees',
  data() {
    return {
      submitIsProcessing: false,
      dialogConfirm: false,
      editItem: null,
    };
  },
  computed: {
    tableData() {
      return this.$store.state.guarantees.guarantees;
    },
  },
  mounted() {
    this.updateList();
  },
  methods: {
    updateList() {
      this.$store.dispatch('guarantees/GetList', {
        profile_id: this.$store.state.user.profile_id,
      });
    },
    showConfirm(item) {
      this.editItem = item;
      this.dialogConfirm = true;
    },
    clearEdit() {
      this.editItem = null;
      this.dialogConfirm = false;
    },
    reSend() {
      const app = this;
      app.submitIsProcessing = true;
      app.$store.getters.axl
        .post('guarantees/api/guarantee/re-send', {
          guarantee_id: this.editItem.id,
          profile_id: this.$store.state.user.profile_id,
        })
        .then(() => {
          app.updateList();
          app.$store.dispatch('ShowInfo', 'Гарантия отправлена клиенту');
          app.clearEdit();
        })

        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        }).finally(() => {
          this.submitIsProcessing = false;
        });
    },
  },
};
